/**
 * @generated SignedSource<<0155545b918736889a93ede4ece7cf2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CheckOutReservationInput = {
  clientMutationId?: string | null | undefined;
  reservationId: string;
};
export type OpsReservationPageCheckOutMutation$variables = {
  input: CheckOutReservationInput;
};
export type OpsReservationPageCheckOutMutation$data = {
  readonly checkOutReservation: {
    readonly reservation: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly assetTag: any | null | undefined;
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsReservationPageCheckOutMutation = {
  response: OpsReservationPageCheckOutMutation$data;
  variables: OpsReservationPageCheckOutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CheckOutReservationPayload",
    "kind": "LinkedField",
    "name": "checkOutReservation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Reservation",
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationPageCheckOutMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsReservationPageCheckOutMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "41d7df272c4be46247dde49757daa96c",
    "id": null,
    "metadata": {},
    "name": "OpsReservationPageCheckOutMutation",
    "operationKind": "mutation",
    "text": "mutation OpsReservationPageCheckOutMutation(\n  $input: CheckOutReservationInput!\n) {\n  checkOutReservation(input: $input) {\n    reservation {\n      id\n    }\n    userErrors {\n      message\n      assetTag\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "acc6a309acfbe028327c3db3fde5a74e";

export default node;
